<template>
  <!-- 실제 input 1개 + 화면에는 6칸 표시 (clt-topt-standard.md 8장) -->
  <div class="otp-boxes" :class="{ 'otp-error': error }" @click="focus">
    <span
      v-for="i in 6"
      :key="i"
      class="otp-box"
      :class="{ active: focused && i - 1 === activeIndex }"
    >
      {{ value[i - 1] || '' }}
    </span>
    <input
      ref="input"
      class="otp-input"
      type="text"
      :value="value"
      maxlength="6"
      inputmode="numeric"
      pattern="\d*"
      autocomplete="one-time-code"
      aria-label="6-digit code"
      :disabled="disabled"
      @input="onInput"
      @paste="onPaste"
      @focus="focused = true"
      @blur="focused = false"
      @keyup.enter="$emit('submit', value)"
    />
  </div>
</template>

<script>
export default {
  name: 'OtpCodeInput',

  props: {
    error: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },

  data: () => ({
    value: '',
    focused: false,
  }),

  computed: {
    activeIndex() {
      return Math.min(this.value.length, 5);
    },
  },

  mounted() {
    this.focus();
  },

  methods: {
    setValue(raw) {
      this.value = String(raw || '').replace(/\D/g, '').slice(0, 6);
      if (this.$refs.input) this.$refs.input.value = this.value;
      this.$emit('input', this.value);
      if (this.value.length === 6) this.$emit('complete', this.value);
    },

    onInput(e) {
      this.setValue(e.target.value);
    },

    // "123 456" 처럼 공백이 섞인 코드도 maxlength 에 잘리기 전에 숫자만 추출
    onPaste(e) {
      const text = (e.clipboardData || window.clipboardData).getData('text');
      if (!text) return;
      e.preventDefault();
      this.setValue(text);
    },

    clear() {
      this.setValue('');
      this.focus();
    },

    focus() {
      this.$nextTick(() => {
        if (this.$refs.input && !this.disabled) this.$refs.input.focus();
      });
    },
  },
};
</script>

<style scoped>
.otp-boxes {
  position: relative;
  display: flex;
  justify-content: center;
  gap: 8px;
  cursor: text;
}
.otp-box {
  width: 46px;
  height: 54px;
  border: 1px solid #c1c7d0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 600;
}
.otp-box.active {
  border-color: #3db6f3;
  box-shadow: 0 0 0 2px rgba(61, 182, 243, 0.3);
}
/* 좁은 화면(모바일)에서 6칸이 넘치지 않도록 */
@media (max-width: 400px) {
  .otp-boxes {
    gap: 6px;
  }
  .otp-box {
    width: 40px;
    height: 48px;
    font-size: 20px;
  }
}
.otp-error .otp-box {
  border-color: #e53935;
}
.otp-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  caret-color: transparent;
  color: transparent;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
}
</style>
